import { StyleObject } from '@styles-api/css.types'

export const scrollableContainer: StyleObject = {
  height: '300px',
  overflowY: 'auto',
  border: '1px solid var(--border-color)',
  padding: '0.5rem',
  borderRadius: 'var(--border-radius)',
  backgroundColor: 'var(--base-color)',
}

export const scrollableContainer2: StyleObject = {
  height: '350px',
  overflowY: 'auto',
  border: '1px solid var(--border-color)',
  padding: '0.5rem',
  borderRadius: 'var(--border-radius)',
  backgroundColor: 'var(--base-color)',
}

export const columnItem: StyleObject = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0.5rem',
  borderBottom: '1px solid var(--border-color-light)',
  ':last-child': {
    borderBottom: 'none',
  },
}

export const columnInfo: StyleObject = {
  flex: 1,
  marginRight: '1rem',
}

export const columnName: StyleObject = {
  fontWeight: 'var(--font-weight-medium)',
  marginBottom: '0.25rem',
  color: 'var(--text-color)',
}

export const columnDescription: StyleObject = {
  fontSize: 'var(--font-size-small)',
  color: 'var(--text-color-muted)',
}

export const transferButtonContainer: StyleObject = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  gap: '1rem',
}

export const selectedColumnActions: StyleObject = {
  display: 'flex',
  gap: '0.5rem',
  alignItems: 'center',
}

export const bulkActionsContainer: StyleObject = {
  marginTop: '1rem',
  display: 'flex',
  gap: '0.5rem',
}

export const gridContainer: StyleObject = {
  gap: '1rem',
}

export const transferButton: StyleObject = {
  minWidth: '2.5rem',
  height: '2.5rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}
